import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ClaimDisputeStatus, ClaimDisputeStatusUtils } from 'src/app/sakp/model/departure-claim';
import { ViolationService } from 'src/app/sakp/services/violations.service';
import { Violation } from 'src/app/sakp/model/violation';
import { disputeStatusToSquare } from 'src/app/sakp/util/css-utils';

@Component({
  selector: 'app-filter-builder-violation-with-status-field',
  templateUrl: './filter-builder-violation-with-status-field.component.html'
})
export class FilterBuilderViolationWithStatusFieldComponent implements OnInit {

  @Input()
  fieldControl: AbstractControl;

  readonly disputeStatusToSquare = disputeStatusToSquare;

  violations: Violation[] = [];
  statuses: ClaimDisputeStatus[] = ClaimDisputeStatusUtils.filterable;

  selectedViolationId: number | null = null;
  selectedStatus: ClaimDisputeStatus | null = null;

  constructor(private violationService: ViolationService, private translateService: TranslateService) {}

  getViolationName(v: Violation): string {
    const lang = this.translateService.currentLang || 'en';
    return v.i18n?.[lang]?.name || v.name;
  }

  get selectedViolation(): Violation | undefined {
    return this.violations.find(v => v.id === this.selectedViolationId);
  }

  ngOnInit(): void {
    this.violations = this.violationService.getAll().reduce((acc, a) => acc.concat(a.violations), [] as Violation[]);

    const current = this.fieldControl?.value as string;
    if (current?.includes(';')) {
      const [id, status] = current.split(';', 2);
      const parsedId = +id;
      if (!isNaN(parsedId)) {
        this.selectedViolationId = parsedId;
        this.selectedStatus = status as ClaimDisputeStatus;
      }
    }
  }

  onSelectionChange(): void {
    if (this.selectedViolationId != null && this.selectedStatus != null) {
      this.fieldControl.setValue(`${this.selectedViolationId};${this.selectedStatus}`);
    } else {
      this.fieldControl.setValue('');
    }
  }
}
